import { teammateDisplayName } from '@littlebird/action-cards';

import { AvatarStack } from '@/components/ui/Avatar';
import { WikiUserAvatar } from '@/features/people-wiki/components/user-avatar';
import { useGroupsQuery } from '@/features/people-wiki/groups/groups.query';
import { cn } from '@/lib/utils';

const SHOWN_AVATARS = 3;

/** The first people of a saved group as overlapping initials, read from the groups the app already loaded. `sizeClassName` is the size of each. */
export const GroupAvatars = ({
  groupName,
  sizeClassName,
}: {
  groupName: string;
  sizeClassName: string;
}) => {
  const { data: groups } = useGroupsQuery({ enabled: false });
  const group = groups?.find(({ name }) => name === groupName);
  if (!group) return null;

  return (
    <AvatarStack>
      {group.members.slice(0, SHOWN_AVATARS).map((member) => (
        <WikiUserAvatar
          key={member.id}
          userId={member.id}
          name={teammateDisplayName(member)}
          className={cn('text-[0.5rem]', sizeClassName)}
        />
      ))}
    </AvatarStack>
  );
};
